/**
 * Routes that already render top chrome themselves
 * (MarketingHeader, DashboardLayout Header, or portal login logo).
 * Layout must not mount the legacy Header on these paths.
 */
const OWN_CHROME_EXACT = new Set([
  '/',
  '/home',
  '/tutor',
  '/tutor/register',
  '/school',
  '/school/register',
  '/admin',
  '/admin/login',
])

const OWN_CHROME_PREFIXES = [
  // Student DashboardLayout
  '/messages',
  '/workspace',
  '/course-materials',
  '/account-settings',
  '/my-tutor',
  '/my-payments',
  '/tutoring-session',
  '/search-results',
  '/subscription',
  '/session-details',
  '/school-profile',
  '/tutor-profile',
  '/written-explanation',
  '/support',
  '/payment',
  '/auth',
  // Tutor DashboardLayout
  '/instructor-dashboard',
  '/tutor/earnings',
  '/tutor/bookings',
  '/tutor/sessions',
  '/tutor/messages',
  '/tutor/profile',
  // School DashboardLayout
  '/school-dashboard',
  '/school/financials',
  '/school/tutors',
  '/school/bookings',
  '/school/analytics',
  '/school/settings',
  // Admin DashboardLayout
  '/admin/dashboard',
  '/admin/users',
  '/admin/support',
  '/admin/updates',
  '/admin/blog',
  '/admin/platform',
  '/admin/ai-settings',
  '/admin/financial',
  '/admin/logs',
  '/admin/sessions',
]

export function pathProvidesOwnChrome(pathname: string): boolean {
  if (OWN_CHROME_EXACT.has(pathname)) return true
  return OWN_CHROME_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  )
}
